<template>
  <div class="app-store-card">
    <div class="img-container">
      <img class="lidl-img" alt="Lidl Connect App" src="/files/lidl/images/new-images/lidl-connect-app.png" />
      <img class="qr-code hide-mobile" src="/files/lidl/images/new-images/app-qr-code.png" alt="" />
    </div>
    <div>
      <h3 class="text-xl">Hol dir die <span class="uppercase">Lidl</span> Connect App</h3>
      <div class="app-card-buttons">
        <a class="app-card-button" href="https://apps.apple.com/de/app/lidl-connect/id1048941506" target="_blank">
          <img src="/files/lidl/images/new-icons/png/apple.png" alt=""/>
          <div class="app-card-button-text">
            <span class="app-card-button-text-top text-xs">
              Download on the
            </span>
            <span class="app-card-button-text-bottom text-sm">
              App Store
            </span>
          </div>
        </a>
        <a class="app-card-button" href="https://play.google.com/store/apps/details?id=de.lidlconnect.android" target="_blank">
          <img src="/files/lidl/images/new-icons/png/google-play.png" alt=""/>
          <div class="app-card-button-text">
            <span class="app-card-button-text-top text-xs">
              Download on
            </span>
            <span class="app-card-button-text-bottom text-sm">
              Google Play
            </span>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppStoreCard'
}
</script>
